import React from 'react';
import icon from './svg/Send';
import { createIconComp } from './Core/createIconComp';


export const SendIcon = createIconComp({ icon });
